import axios from 'axios';
import queryString from 'qs';
import cleanDeep from 'clean-deep';
import {isEmpty, isUndefined} from 'lodash/lang';
import {assign, get} from 'lodash/object';
import Cookies from 'utils/cookies';
import {API_URL, IS_STAGE_DEV} from 'configs';

export const queryParse = (string) => {
  return queryString.parse(string, {ignoreQueryPrefix: true});
};

export const queryStringify = (obj, options) => {
  return queryString.stringify(obj, options);
};

export const makeSearchParams = (queries = {}) => {
  if (isEmpty(queries)) return {};

  if (typeof queries === 'string') {
    queries = queryParse(queries);
  }

  const {limit, offset, order, order_by, key, ...rest} = queries;

  let params = {
    limit: isUndefined(limit) ? 20 : limit,
    offset: isUndefined(offset) ? 0 : offset,
    key: isUndefined(key) ? '' : key,
  };

  if (!isUndefined(order)) params.order = order;
  if (!isUndefined(order_by)) params.order_by = order_by;
  if (!isEmpty(rest))
    params.filter = {
      ...rest,
    };

  return params;
};

/**
 * Global axios defaults
 */
export const setAxiosConfig = () => {
  // axios setup
  axios.defaults.baseURL = API_URL;

  // bsid (browser unique ID)
  axios.defaults.headers.common['x-http-bsid'] = Cookies.bsid;
};

const http = (method = 'GET', url, data, options) => {
  let instance = axios.create();

  let args = {};

  // Set Request
  args.method = method;
  args.url = url;

  // Set Request Data
  if (method.toUpperCase() === 'GET') {
    args.params = cleanDeep(data);
  } else {
    args.data = data;
  }

  // Set options
  if (!isEmpty(options)) {
    args = assign({}, args, options);
  }

  // Set Token

  const captchaToken = Cookies.captchaToken || '';
  const token = Cookies.session || '';

  args = assign(
    {},
    {
      headers: {
        'x-http-token': isEmpty(token) ? '' : token,
        'x-http-captcha-token': isEmpty(captchaToken) ? '' : captchaToken,
      },
    },
    args
  );

  return instance(args)
    .then(({data}) => data)
    .catch((error) => {
      let result;
      const response = get(error, 'response', {});

      if (!isEmpty(response)) {
        const status = get(error, 'response.status', '');
        const data = get(error, 'response.data.data', {});
        const message = get(error, 'response.data.errors.message', '');
        const code = get(error, 'response.data.errors.code', '');
        const token = get(error, 'response.data.token', '');

        const errors = get(error, 'response.data.errors', {});

        result = {
          error: true,
          status: status,
        };

        if (Array.isArray(errors)) {
          result.errors = errors;
        } else {
          result = {
            ...result,
            ...errors,
          };
        }

        if (!isEmpty(data)) result.data = data;
        if (!isEmpty(message)) result.message = message;
        if (!isEmpty(token)) result.token = token;
        if (!isEmpty(code)) {
          result.code = status === 500 || status === '500' ? 'NOT_FOUND' : code; // Blocking to show 500 error.;
        }

        if (code === 'invalid_session_token') {
          Cookies.session = '';

          // @OLD: `/error/${status}`
          const redirectTo = `/login`;

          // @TODO: Redirect to login page with redirect url in the `src/utils/render-routes.js`
          window.location.replace(redirectTo);
        } else if (code === 'invalid_captcha_token') {
          Cookies.captchaToken = '';
        } else if (status === 404 || status === '404') {
          if (!IS_STAGE_DEV) window.location.replace(`/error/${status}`);
        } else if (status === 500 || status === '500') {
          if (!IS_STAGE_DEV) window.location.replace(`/error/${status}`);
        }
      } else {
        result = error;
      }

      throw result;
    });
};

export default http;
